import { Icon, SvgCrop169, SvgCropExpanded169 } from '@loomhq/lens';
import React from 'react';

import ControlBarButton from '../control-bar-button';

import './styles.less';

export default function TheaterModeButton(props) {
  const hoverTagText = props.theaterMode
    ? 'Default Mode (t)'
    : 'Theater Mode (t)';

  return (
    <ControlBarButton
      className="video-player-theater-mode-button"
      hoverTagText={hoverTagText}
      seeking={props.seeking}
      onClick={props.onClick}
      inTrimMode={props.inTrimMode}
    >
      <Icon
        color={props.inTrimMode ? 'disabledContent' : 'white'}
        className="control-bar-button-icon"
        icon={props.theaterMode ? <SvgCrop169 /> : <SvgCropExpanded169 />}
      />
    </ControlBarButton>
  );
}
